import cn from 'classnames';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { FormLabel, PhoneInput } from '@infologistics/frontend-libraries';

import { getErrorText, getInitialCountryPhone, getPreferredCountries } from '@utils/utils';
import { BrowserStorage, Instance, UserField } from '@const/consts';
import { AuthTranslations, Warning } from '@const/translations';
import { IApplicationState } from '@store/types/commonTypes';
import { IPhoneInputWrapperProps as IProps } from './types';
import { IPhoneInputChangeEvent } from '@app/types';

import styles from '../../../../../AuthNew.module.scss';
import { LoginButtons } from '../../../LoginButtons';

const PhoneInputWrapper: FC<IProps> = (props) => {
  const { onEmailLoginClick, onContinueBtnClick, onSSOLoginClick, onServerErrorChange, setErrors, errors, values, setFieldValue } = props;

  const { t } = useTranslation();
  const instanceFromStore = useSelector((state: IApplicationState) => state.utils.instance);
  const instance = localStorage.getItem(BrowserStorage.INSTANCE) ?? instanceFromStore ?? Instance.GLOBAL;
  const isError = !!errors[UserField.PHONE];

  const handleContinueBtnClick = (): void => {
    if (!values.phone) {
      setErrors({ [UserField.PHONE]: Warning.required });
      return;
    }
    onContinueBtnClick();
  };

  const handlePhoneChange = (e: IPhoneInputChangeEvent): void => {
    setFieldValue?.(UserField.PHONE, e.target.value || null);
  };

  const handleLoginByEmailClick = (): void => {
    onEmailLoginClick();
    onServerErrorChange(undefined);
  };

  const handleLoginBySSOClick = (): void => {
    onSSOLoginClick();
    onServerErrorChange(undefined);
  };

  return (
    <>
      <div className='mb-6'>
        <FormLabel htmlFor={UserField.PHONE} text={t('user:phone')} className={cn(styles.label, 'text-muted')} />
        <PhoneInput
          id={UserField.PHONE}
          name={UserField.PHONE}
          onChange={handlePhoneChange}
          hasError={isError}
          errorText={t(getErrorText(UserField.PHONE, errors))}
          value={values[UserField.PHONE] ?? null}
          size='md'
          preferredCountries={getPreferredCountries(instance)}
          initialCountry={getInitialCountryPhone(instance)}
          classes={{
            // wrapper: cn(styles.input),
            input: cn(styles.inputs, styles.input_radius, styles.phone_input),
          }}
        />
      </div>

      <LoginButtons
        isDisabled={isError}
        main={{
          onClick: handleContinueBtnClick,
          text: AuthTranslations.continue,
        }}
        left={{
          onClick: handleLoginByEmailClick,
          text: AuthTranslations.loginByEmail,
        }}
        right={{
          onClick: handleLoginBySSOClick,
          text: AuthTranslations.loginBySSO,
        }}
      />
    </>
  );
};

export default PhoneInputWrapper;
